import { defineMessages } from 'react-intl';

export const messages: {
	deleteMemory: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteMemoryTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyListHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyListDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	disabledHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	disabledDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteConfirmHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteConfirmDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteConfirmCancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteConfirmRemove: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadingDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorRetry: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	deleteMemory: {
		id: 'ai-mate.rovo-memories.memory-list.delete-memory',
		defaultMessage: 'Delete',
		description: 'Label for the delete memory action',
	},
	deleteMemoryTooltip: {
		id: 'ai-mate.rovo-memories.memory-list.delete-memory-tooltip',
		defaultMessage: 'Remove memory',
		description: 'Tooltip for the delete memory button',
	},
	emptyListHeading: {
		id: 'ai-mate.rovo-memories.memory-list.empty-list.heading',
		defaultMessage: 'Ready to remember!',
		description: 'Heading shown when memory list is empty (user has no memories)',
	},
	emptyListDescription: {
		id: 'ai-mate.rovo-memories.memory-list.empty-list.description',
		defaultMessage:
			'Rovo will automatically save details from your chats. You can also tell Rovo to remember things about you and how you like to work.',
		description: 'Description shown when memory list is empty',
	},
	disabledHeading: {
		id: 'ai-mate.rovo-memories.memory-list.no-memories.heading',
		defaultMessage: 'Memories are disabled',
		description:
			'Heading shown when memory list is disabled (Rovo not allowed to use past conversations)',
	},
	disabledDescription: {
		id: 'ai-mate.rovo-memories.memory-list.no-memories.description',
		defaultMessage:
			'Rovo is still storing memories about you, but won’t use them in replies until you turn personalization on again.',
		description: 'Description shown when memory list is disabled (memories stored but not used)',
	},
	deleteConfirmHeading: {
		id: 'ai-mate.rovo-memories.memory-list.delete-confirm.heading',
		defaultMessage: 'Are you sure you want to remove this memory?',
		description: 'Heading for the delete memory confirmation prompt',
	},
	deleteConfirmDescription: {
		id: 'ai-mate.rovo-memories.memory-list.delete-confirm.description',
		defaultMessage:
			"Rovo won't remember this detail when responding in the future. Your chat history won't be affected.",
		description: 'Description for the delete memory confirmation (impact of removal)',
	},
	deleteConfirmCancel: {
		id: 'ai-mate.rovo-memories.memory-list.delete-confirm.cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button in delete memory confirmation',
	},
	deleteConfirmRemove: {
		id: 'ai-mate.rovo-memories.memory-list.delete-confirm.remove',
		defaultMessage: 'Remove',
		description: 'Confirm remove button in delete memory confirmation',
	},
	loadingDescription: {
		id: 'ai-mate.rovo-memories.memory-list.loading.description',
		defaultMessage: 'Loading memories...',
		description: 'Description shown while memories are being loaded',
	},
	errorHeading: {
		id: 'ai-mate.rovo-memories.memory-list.error.heading',
		defaultMessage: "Rovo couldn't load your memories",
		description: 'Heading shown when memories fail to load',
	},
	errorDescription: {
		id: 'ai-mate.rovo-memories.memory-list.error.description',
		defaultMessage:
			'Your memories are still stored safely, but Rovo can’t load them right now. Please try again.',
		description: 'Description shown when memories fail to load',
	},
	errorRetry: {
		id: 'ai-mate.rovo-memories.memory-list.error.retry',
		defaultMessage: 'Retry loading',
		description: 'Retry loading memories button in error state',
	},
	searchPlaceholder: {
		id: 'ai-mate.rovo-memories.memory-list.search.placeholder',
		defaultMessage: 'Search memories',
		description: 'Placeholder text for the search input in the memory list',
	},
	searchLabel: {
		id: 'ai-mate.rovo-memories.memory-list.search.label',
		defaultMessage: 'Search memories',
		description: 'Accessible label for the search input in the memory list',
	},
});
